'use client';

import {
  PointStatus,
  useAddressStore,
} from '@/entities/address/model/use-address-store';
import { useEffect, useMemo, useRef, useState } from 'react';
import Mobile from './responsive/mobile';

const defaultGeometry: [number, number] = [41.31119825, 69.27975936];

const Delivery = ({ onClose }: { onClose: () => void }) => {
  const { map, points, editing_point } = useAddressStore();

  const [accommodation, setAccommodation] = useState<string>('');
  const [addressName, setAddressName] = useState<string>('');
  const [isLoading] = useState(false);
  const [city, setCity] = useState<string>('');
  const [geometry, setGeometry] = useState<[number, number]>(defaultGeometry);
  const [markerCoords, setMarkerCoords] =
    useState<[number, number]>(defaultGeometry);

  const mapRef = useRef<any>(null);
  const timer = useRef(setTimeout(() => {}, 3000));

  const activePoint = useMemo(
    () => points?.find((item) => item.status === PointStatus.ACTIVE),
    []
  );

  const handleClear = () => {
    setAddressName('');
    setCity('');
  };

  const onAddressSelect = (e: any) => {
    setAddressName(e?.address);
    setMarkerCoords(e?.location);
    mapRef?.current?.setCenter([e?.location?.[0], e?.location?.[1]], 18, {
      duration: 300,
    });
  };

  const onChange = (
    value: {
      address: string;
      city: string;
      house: string;
      location: number[];
    },
    isSelect: boolean
  ) => {
    if (isSelect) {
      setMarkerCoords([value?.location[0], value?.location[1]]);
    }
    setCity(value.city);
    setAddressName(value.address);
    setAccommodation(value.house);

    clearTimeout(timer.current);
  };

  useEffect(() => {
    if (activePoint?.location?.[0] && activePoint?.location?.[1]) {
      setGeometry(activePoint?.location);
    } else {
      setGeometry(defaultGeometry);
    }
  }, [activePoint]);

  // Get details of point when editing it
  useEffect(() => {
    if (editing_point) {
      setCity(editing_point?.city);
      setAddressName(editing_point?.address);
      if (editing_point?.location) {
        setGeometry(editing_point?.location);
        setMarkerCoords(editing_point?.location);
      }
    }
  }, [map, editing_point]);

  const commonProps = {
    city,
    mapRef,
    onClose,
    onChange,
    geometry,
    isLoading,
    addressName,
    handleClear,
    markerCoords,
    accommodation,
    onAddressSelect,
    onMapBounded: (ll: number[]) => setMarkerCoords([ll[0], ll[1]]),
  };

  return <Mobile {...commonProps} />;
};

export default Delivery;
